import { Vector3 } from "@babylonjs/core/Maths/math.vector";
import { ElementChangedFlags } from '@egr/wcf/modules/core/mdl';
import { AbstractInteractorTool } from './tools';
import { EditRoomElement } from './../cmd/EditRoomElement';
import { RoomElementSnapping } from './RoomElementSnapping';
export class MoveCircle extends AbstractInteractorTool {
    constructor(pRoomManager) {
        super(pRoomManager);
        this.mCommand = null;
        this.mLengthFeedback = null;
    }
    initialize(pMode, pRoomElement) {
        this.mMode = pMode;
        this.mRoomElement = pRoomElement;
        this.mCommand = new EditRoomElement(this.mRoomManager, this.mRoomElement);
        this.mRESnapping = new RoomElementSnapping(this.mRoomManager);
        this.mInitialPointMove = true;
        this.mMoved = false;
        this.mRoomElement.setToolRunning(true);
        this.mRoomElement.setTransformStatus("Transform");
        this.mRoomElement.updateGeometry(false, false);
        this.mRoomElement.setMeshVisibility(0.5);
        this.prepareSnapping();
        this.mRoomManager.beginInteraction();
    }
    stop() {
        if (this.mCommand != null) {
            this.mCommand.cancel();
            this.mCommand = null;
        }
        this.mRoomElement.setMeshVisibility(1, true);
        this.mRoomManager.endInteraction();
        super.stop();
    }
    //// protected /////////////////////////////////////////////////////////////////////////////
    startPos(pPos) {
        //
    }
    updatePointerPosition(pPos) {
        let tNPos = this.mRoomElement.node.position;
        let tREgeo = this.mRoomElement.geometry;
        let t_Points = tREgeo.getPoints();
        let tPoints = new Array();
        for (let tPoint of t_Points) {
            tPoints.push(tPoint.clone());
        }
        let tnewPos = this.performSnapping(pPos);
        let tDiff = tnewPos.subtract(tNPos);
        this.mRoomElement.setToolRunning(true);
        switch (this.mMode) {
            case MoveCircle.Mode.MovePoint:
                if (this.mInitialPointMove) {
                    this.mInitialPointMove = false;
                }
                // change radius/diameter
                tPoints[1].x = tPoints[0].x + tDiff.x;
                tPoints[1].y = 0;
                tPoints[1].z = tPoints[0].z + tDiff.z;
                let tL1 = Vector3.Distance(tPoints[0], tPoints[1]);
                if (tL1 >= 0.05) {
                    tREgeo.setPoints(tPoints);
                    this.mRoomElement.updateGeometry(false);
                }
                this.mMoved = false;
                break;
            case MoveCircle.Mode.Move_Circle:
                if (this.mInitialPointMove) {
                    this.mInitialPointMove = false;
                }
                this.mRoomElement.setPosition(tnewPos);
                this.mMoved = true;
                break;
            default:
                break;
        }
        this.mApp.rendering.notifyModelInteraction();
        if (this.mView != null)
            this.mView.viewer.requestRenderFrame();
    }
    finish() {
        if (!this.mMoved) {
            // re-align circle
            let tREgeo = this.mRoomElement.geometry;
            let tPoints = tREgeo.getPoints();
            if (tPoints.length !== 2)
                return;
            if (tPoints[0] == null || tPoints[1] == null)
                return;
            let toffset = tPoints[0].clone();
            tPoints[0] = tPoints[0].subtract(toffset);
            tPoints[1] = tPoints[1].subtract(toffset);
            tREgeo.setPoints(tPoints);
            this.mRoomElement.setTransformStatus("");
            this.mRoomElement.updateGeometry(true, false);
        }
        this.mInitialPointMove = true;
        this.mRoomElement.setToolRunning(false);
        this.mRoomElement.notifyChange(ElementChangedFlags.PropertyValues);
        this.mRoomElement.notifyChange(ElementChangedFlags.Properties);
        this.mRoomElement.notifyChange(ElementChangedFlags.BoundingBox);
        this.mRoomElement.updateGeometry();
        this.mRoomManager.setTransformationDepth(0);
        if (this.mCommand !== null) {
            this.mApp.commands.executeCommand(this.mCommand).then(() => {
                if (this.mRoomElement.type !== "Sphere") {
                    this.mRoomManager.TransformShape();
                }
                this.mCommand = null;
                this.stop();
            });
        }
    }
    prepareSnapping() {
        super.prepareSnapping();
        this.mRESnapping.prepareSnapping(this.mRoomElement);
    }
    prepareFeedback() {
        super.prepareFeedback();
        // this.mLengthFeedback = new RoomElementInteractors(this.mRoomManager, this.mRoomElement);
        // this.mLengthFeedback.showInteractors(false, true);
        // this.mLengthFeedback.manager.fixedView = this.mView;
    }
    updateFeedback() {
        super.updateFeedback();
        this.mRoomElement.showInteractors(false, true);
        // if (this.mLengthFeedback != null){
        //     this.mRoomElement.setInteractorVisible(true);
        //     this.mLengthFeedback.showInteractors(false, true);
        // }
    }
    clearFeedback() {
        super.clearFeedback();
        // if (this.mLengthFeedback != null) {
        //     this.mLengthFeedback.clear();
        //     this.mLengthFeedback = null;
        // }
    }
    performSnapping(pPos) {
        return (this.mRESnapping.snap(pPos, this.mView));
    }
}
//add nested types
(function (MoveCircle) {
    let Mode;
    (function (Mode) {
        Mode[Mode["MovePoint"] = 0] = "MovePoint";
        Mode[Mode["Move_Circle"] = 1] = "Move_Circle";
    })(Mode = MoveCircle.Mode || (MoveCircle.Mode = {}));
})(MoveCircle || (MoveCircle = {}));
